module.exports = __webpack_public_path__ + "public/img/cgms.3bf5e151.png";